import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { WarehousePositionForm } from './-form'
import { Button } from '@/components/ui/button'
import {
    useDeleteWarehousePosition,
    useUpdateWarehousePosition,
    useWarehousePosition,
} from '@/hooks/use-warehouse-position-query'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/warehouse-positions/$id',
)({
    component: WarehousePositionDetailPage,
})

function WarehousePositionDetailPage() {
    const { id } = Route.useParams()
    const navigate = useNavigate()
    const { data: envelope, isLoading } = useWarehousePosition(id)
    const update = useUpdateWarehousePosition(id)
    const remove = useDeleteWarehousePosition()

    const p = envelope?.data

    if (isLoading || !p) {
        return <div className="p-4">{m.warehouse_position_loading()}</div>
    }

    return (
        <div className="space-y-4 p-4 md:space-y-6 md:p-6">
            <h1 className="text-xl font-semibold">
                {m.warehouse_position_edit_title()}
            </h1>
            <WarehousePositionForm
                submitLabel={m.warehouse_position_submit_save()}
                codeHint={m.warehouse_position_code_edit_warning()}
                defaultValues={{
                    code: p.code,
                    name: p.name ?? '',
                    applicable_lot_types: p.applicable_lot_types,
                }}
                onSubmit={async (data) => {
                    await update.mutateAsync({
                        code: data.code,
                        name: data.name || null,
                        applicable_lot_types: data.applicable_lot_types,
                    })
                }}
                footerExtra={
                    p.is_active ? (
                        <Button
                            type="button"
                            variant="destructive"
                            className="flex-1 md:flex-none"
                            onClick={async () => {
                                if (
                                    !confirm(
                                        m.warehouse_position_confirm_delete(),
                                    )
                                )
                                    return
                                await remove.mutateAsync(id)
                                void navigate({
                                    to: '/warehouse-positions',
                                    search: { page: 1 },
                                })
                            }}
                        >
                            {m.warehouse_position_inactive()}
                        </Button>
                    ) : null
                }
            />
        </div>
    )
}
